import styled from "styled-components";

export const CardContainer = styled.div`
  border: 1px solid var(--color-neutral-200);
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  width: 100%;
`;

export const CardTitle = styled.div`
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.15px;
  color: var(--color-accent);
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;

  text-align: left;
`;

// Esse e o tamanho maximo da imagem que vem pela api
export const ImageContainer = styled.img`
  width: 55px;
  height: 55px;
`;

export const GridContainer = styled.div`
  margin-top: 8px;
`;

export const GridRow = styled.div<{ $index: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 34px;
  align-items: center;
  padding: 0 16px;
  background-color: ${({ $index }) =>
    $index % 2 === 0 ? "var(--color-bg)" : "#F8F9F9"};

  & > * {
    min-width: 0;
  }
`;

export const GridLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-muted);
  text-align: left;
`;

export const GridValue = styled.span<{ $overflows?: boolean }>`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text);
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: ${({ $overflows }) => ($overflows ? "pointer" : "default")};
`;
